import { combineReducers } from 'redux'
import { logsReducer } from './reducers/logs'
import { apisReducer } from './reducers/apis'
import { authReducer } from './reducers/auth'

/**
 * ## CombineReducers
 *
 * the rootReducer will call each and every reducer with the state and action
 * EVERY TIME there is a basic action
 */

export const rootReducer = combineReducers({
  logs: logsReducer,
  apis: apisReducer,
  auth: authReducer,
})
